<template>
  <li class="overflow-menu-item" :class="{ disabled }"
      :key="itemKey"
      @click.stop="itemClicked"
      @keyup.enter.stop="itemClicked"
      tabindex="0"
      role="menuitem"
      :aria-label="text">
    <icon :iconName="iconName" v-if="iconName" :color="iconColor" fill class="icon" :optical-size="24"/>
    <img class="icon-img" :src="iconSrc" alt="Menu item icon" v-if="iconSrc && !iconName">
    <span class="item-text">{{ text }}</span>
  </li>
</template>

<script>

import ClickOutside from '../../directives/click-outside';
import Icon from '../Icon.vue';

export default {
  name: 'OverflowMenuItem',
  components: { Icon },
  directives: {
    ClickOutside,
  },
  props: {
    itemKey: {
      type: String,
      required: true,
    },
    onItemClick: {
      type: Function,
      required: true,
    },
    iconSrc: {
      type: String,
      required: false,
    },
    iconName: {
      type: String,
      required: false,
    },
    iconColor: {
      type: String,
      required: false,
    },
    text: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    itemClicked() {
      if (!this.disabled) {
        this.onItemClick(this.itemKey);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './overflow-menu.styles';
</style>
